// store.js
import { configureStore } from "@reduxjs/toolkit";
import apiReducer from "./apiReducer";
import appReducer from "./appReducer";

// Create Redux store
const store = configureStore({
  reducer: {
    api: apiReducer,  // Attach API reducer
    app: appReducer,  // Attach App/UI state reducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false,
    }),
});

export default store;
